import ImageZoom from './image-zoom';

export default ImageZoom;
